import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface InspectionState {
	selectedMemberUserId: number | null;
	selectedMemberId: string | null;
	selectedApplicationId: string | null;
	numericApplicationId: number | null;
}

const initialState: InspectionState = {
	selectedMemberUserId: null,
	selectedMemberId: null,
	selectedApplicationId: null,
	numericApplicationId: null,
};

const inspectionSlice = createSlice({
	name: "inspection",
	initialState,
	reducers: {
		setSelectedMember: (
			state,
			action: PayloadAction<{
				userId: number;
				memberId: string;
				applicationId: string;
				numericApplicationId: number;
			}>,
		) => {
			state.selectedMemberUserId = action.payload.userId;
			state.selectedMemberId = action.payload.memberId;
			state.selectedApplicationId = action.payload.applicationId;
			state.numericApplicationId = action.payload.numericApplicationId;
		},
		clearSelectedMember: state => {
			state.selectedMemberUserId = null;
			state.selectedMemberId = null;
			state.selectedApplicationId = null;
			state.numericApplicationId = null;
		},
	},
});

export const { setSelectedMember, clearSelectedMember } = inspectionSlice.actions;
export default inspectionSlice.reducer;
